import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, specraButtonVariants } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageBody, PageHero } from '../../components/layout';
import { useRecordBreadcrumbs } from '../../components/RecordShell/useRecordBreadcrumbs';
import { useLayoutStore } from '../../lib/stores/LayoutStore';
import { growthCrumbs } from '../GrowthHub/growthCrumbs';
import { AccessNote } from './components/AccessNote';
import { LandscapeList } from './components/LandscapeList';
import { PortfolioTotalCard } from './components/PortfolioTotalCard';
import { useLandscapeParams } from './hooks/useLandscapeParams';
import { useLandscapes } from './hooks/useLandscapes';
import { usePortfolioEconomics } from './hooks/usePortfolioEconomics';
import { downloadCsv, economicsCsv } from './portfolioEconomics';
export function LandscapesPage() {
    const params = useLandscapeParams();
    const { data = [], isLoading, error } = useLandscapes();
    const economics = usePortfolioEconomics();
    const setShowHeader = useLayoutStore((s)=>s.setShowHeader);
    useEffect(()=>{
        setShowHeader(false);
        return ()=>setShowHeader(true);
    }, [
        setShowHeader
    ]);
    useRecordBreadcrumbs(growthCrumbs({
        label: 'Landscapes'
    }));
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": Testids.landscapes.page,
        children: /*#__PURE__*/ _jsxs(PageBody, {
            padding: "page",
            children: [
                /*#__PURE__*/ _jsx(PageHero, {
                    title: "Landscapes",
                    subtitle: "Named groupings of opportunities for planning",
                    actions: /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraButton, {
                                size: "sm",
                                variant: "outline",
                                disabled: !economics.data,
                                "data-testid": Testids.portfolio.exportButton,
                                onClick: ()=>{
                                    if (economics.data) downloadCsv('landscape-economics.csv', economicsCsv(economics.data));
                                },
                                children: "Export CSV"
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                to: "/landscapes/new",
                                className: specraButtonVariants({
                                    size: 'sm'
                                }),
                                "data-testid": Testids.landscapes.newButton,
                                children: "New Landscape"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-4",
                    children: [
                        /*#__PURE__*/ _jsx(AccessNote, {}),
                        /*#__PURE__*/ _jsx(PortfolioTotalCard, {}),
                        isLoading && /*#__PURE__*/ _jsx("p", {
                            className: "text-sm text-muted-foreground",
                            children: "Loading…"
                        }),
                        error && /*#__PURE__*/ _jsx("p", {
                            className: "text-sm text-muted-foreground",
                            children: "Could not load Landscapes."
                        }),
                        !isLoading && !error && /*#__PURE__*/ _jsx(LandscapeList, {
                            landscapes: data,
                            landscapeFilter: params.landscape,
                            organizationFilter: params.organization,
                            listSearch: params.search,
                            economics: economics.data?.landscapes,
                            onLandscapeFilter: params.setLandscape,
                            onOrganizationFilter: params.setOrganization
                        })
                    ]
                })
            ]
        })
    });
}
